'use strict';

var _ = require('lodash');
var CompetitorFaresChartPanelDirective = function CompetitorFaresChartPanelDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/competitor-fares-chart-panel.html'),
    controller: 'CompetitorFaresChartPanelController',
    scope: {
      screen: '@',
      mode: '@',
      brushFilterType: '@',
      visible: '=',
      selectedRows: '=',
      metrics: '=',
      selectedEntity: '=',
      isExpandedModeEnabled: '='
    },
    link: function link(scope) {
      scope.$watch('selectedRows', _.debounce(function () {
        scope.resetFilters();
        scope.$broadcast('competitor-fare-chart:resetQuickFilter');
        scope.selectedServices = _.chain(scope.selectedRows).uniqBy('serviceId').value();
        scope.delayedReload();
      }, 500, {
        leading: true,
        trailing: false
      }));
      scope.delayedReload = function (mode) {
        if (scope.visible) {
          var serviceMode = mode === 'service';
          scope.timeoutReload(!serviceMode);
        }
      };
      scope.timeoutReload = function (mode) {
        $timeout(scope.reloadChart, 0, mode);
      };
      scope.$watchGroup(['visible', 'selectedEntity'], function (newValues) {
        if (newValues[0]) {
          scope.timeoutReload();
        }
      });
      scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
        scope.modeDifferFromVisible = mode !== scope.mode;
        if (mode === scope.mode && scope.visible) {
          scope.timeoutReload();
        } else {
          scope.$broadcast('competitor-fare-chart:resetQuickFilter');
        }
      });
      function isOneFlightSelected(brushFilter) {
        return brushFilter.filterType === 'flightLevel' && brushFilter.filterArguments[0].length === 1;
      }
      function isOneDaySelectedOnMarketScreen(brushFilter) {
        if (brushFilter.filterType !== 'dateRange' || brushFilter.isEmpty() || scope.screen !== 'MARKET_SCREEN') {
          return false;
        }
        var filterArguments = brushFilter.filterArguments[0];
        return filterArguments[0].from.valueOf() === filterArguments[0].to.valueOf();
      }
      scope.$on('brush-filter:filterApplied', function (event, brushFilter) {
        if (isOneFlightSelected(brushFilter) || isOneDaySelectedOnMarketScreen(brushFilter)) {
          scope.legendFilter = [];
          scope.reloadChart();
        }
      });
    }
  };
};
CompetitorFaresChartPanelDirective.$inject = ['$timeout'];
module.exports = CompetitorFaresChartPanelDirective;